import axios from "axios"

export default {
  data() {
    return {
      apiError: false,
      pendingRequests: 0,
      globalUrls: [
        "lasttenyears",
        "nightsrecap",
        "periodRecap",
        "countries",
        "latestHestaPeriod",
        "last12Months",
        "getCantonDestinations",
        "GetListingsOverYears",
        "getGenderPeriod",
        "getAgeGroupsPeriod",
        "getDayOfWeekPeriod",
        "getDwellTimesPeriod",
        "getCountriesPeriod",
        "getCantonsPeriod",
        "getMunicipalitiesPeriod",
        "GetHourlyVisitors",
        "GetPeriodManagersKPIs"
      ]
    };
  },
  created() {
    this.setInterceptors();
  },
  methods: {
    setInterceptors() {
      /*
       ** Interceptors not set globally, in order to avoid disturbing list loading
       */
       axios.interceptors.request.use(
        config => {
          // Check if global requests are pending
          console.log("config.url", config.url);
          if (this.isGlobalRequests(config.url))
            this.incrementPendingRequests();

          //  Generate cancel token source
          let source = axios.CancelToken.source();
          // Set cancel token on this request
          config.cancelToken = source.token;
          // Add to vuex to make cancellation available from anywhere
          this.$store.commit("axiosCancel/ADD_CANCEL_TOKEN", source);
          return config;
        },
        error => {
          return Promise.reject(error);
        }
      );
      axios.interceptors.response.use(
        response => {
          if (this.isGlobalRequests(response.config.url))
            this.decrementPendingRequests();

          return response;
        },
        error => {
          if (error.message != "cancelled") this.decrementPendingRequests();
          return Promise.reject(error);
        }
      );
    },
    cancelPreviousRequests() {
      //this.$store.dispatch("axiosCancel/CANCEL_PENDING_REQUESTS");
      this.resetPendingRequests();
    },
    resetPendingRequests() {
      this.pendingRequests = 0;
    },
    incrementPendingRequests() {
      this.pendingRequests++;
    },
    decrementPendingRequests() {
      if (this.pendingRequests > 0) this.pendingRequests--;
    },
    isGlobalRequests(url) {
      let count = 0;
      this.globalUrls.forEach(singleUrl => {
        if (url.includes(singleUrl)) count++;
      });
      return count > 0;
    },
    resetTrackers() {
      this.apiError = false;
    }
  }
}
